import { render } from "./NoSidebar.vue?vue&type=template&id=8e467ebe&ts=true"
import script from "./NoSidebar.vue?vue&type=script&lang=ts"
export * from "./NoSidebar.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/com.latudio.www.teachers_staging/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__